class ToDoListTableFilterMap {
  constructor() {
    // @ts-ignore
    this.map = new Map();
    // @ts-ignore
    this.map.set("transactionId", "TransactionID");
    // @ts-ignore
    this.map.set("actionCompletedDate", "ActionCompletedDate");
    // @ts-ignore
    this.map.set("dueDate", "DueDate");
    // @ts-ignore
    this.map.set("receiveDate", "ReceiveDate");
    // @ts-ignore
    this.map.set("requestBy", "RequestBy");
    // @ts-ignore
    this.map.set("processInitiateDate", "ProcessInitiateDate");
    // @ts-ignore
    this.map.set("processInitiator", "ProcessInitiator");
    // @ts-ignore
    this.map.set("accountName", "AccountID");
    // @ts-ignore
    this.map.set("taskGroup", "ProcedureTaskGroupID");
    // @ts-ignore
    this.map.set("category", "Path");
    // @ts-ignore
    this.map.set("taskId", "TaskID");
    // @ts-ignore
    this.map.set("taskLabelName", "TaskLabelName");
    // @ts-ignore
    this.map.set("highlyRegulated", "HighRegulated");
    // @ts-ignore
    this.map.set("delegatedBy", "DelegatedBy");
    // @ts-ignore
    this.map.set("delegateTo", "DelegatedTo");
  }

  set(key: any, value: any) {
    // @ts-ignore
    this.map.set(key, value);
  }

  get(key: any) {
    // @ts-ignore
    return this.map.get(key);
  }
}

const toDoListTableFilterMap = new ToDoListTableFilterMap();

export default toDoListTableFilterMap;
